import React, {FC} from 'react';

import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {findThemedImageInfo, ThemedImageNamesEnum} from '../../../helpers/imageThemeHelpers';

/*
 * Props.
 */

export interface ThemedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  image: ThemedImageNamesEnum;
}

/*
 * Component.
 */

export const ThemedImage: FC<ThemedImageProps> = ({image, ...props}) => (
  <img {...findThemedImageInfo(useUserTheme(), image)} alt="" {...props} />
);
